import script from "./LightItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LightItem.vue?vue&type=script&setup=true&lang=js"

import "./LightItem.vue?vue&type=style&index=0&id=16709bf2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16709bf2"]])

export default __exports__